export default function AppSection() {
  return (
    <section id="app" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-400 flex items-center justify-center shadow-lg shadow-primary-200/30">
            <i className="ri-smartphone-line text-background-50 text-5xl md:text-6xl"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
              随时随地，畅享在线视频
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-2xl">
              青青草视频全面适配移动端浏览体验，无论您使用手机还是平板，都能流畅访问久久视频、芒果视频、97视频、丝瓜视频等平台入口。打开即用、无需下载，高清视频网站体验随手可得。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-foreground-600 text-xs font-medium">
                <i className="ri-apple-fill text-sm"></i>
                iOS 适配
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-foreground-600 text-xs font-medium">
                <i className="ri-android-fill text-sm"></i>
                Android 适配
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-foreground-600 text-xs font-medium">
                <i className="ri-tablet-line text-sm"></i>
                平板支持
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}